import MuiBadge, { BadgeProps as MuiBadgeProps } from '@mui/material/Badge';

import { Icon, IconDefinition } from './Icon';

interface BadgeProps extends MuiBadgeProps {
  icon?: IconDefinition;
}

export const Badge: React.FC<BadgeProps> = ({
  icon,
  badgeContent,
  color = 'primary',
  sx,
  ...otherProps
}) => {
  if (icon) {
    return (
      <MuiBadge
        badgeContent={<Icon size="xsmall" icon={icon} />}
        color={color}
        sx={[
          { '& .MuiBadge-badge': { p: 0, fontSize: '0.75em' } },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...otherProps}
      ></MuiBadge>
    );
  }

  return (
    <MuiBadge
      badgeContent={badgeContent}
      color={color}
      sx={sx}
      {...otherProps}
    ></MuiBadge>
  );
};
